import type { DigilockerEvent, DigilockerEventType, DigilockerEventEmitter } from '../types/digilocker';

export class EventEmitter implements DigilockerEventEmitter {
  private listeners: Map<DigilockerEventType, Set<(event: DigilockerEvent) => void>> = new Map();

  on(event: DigilockerEventType, callback: (event: DigilockerEvent) => void): void {
    if (!this.listeners.has(event)) {
      this.listeners.set(event, new Set());
    }
    this.listeners.get(event)!.add(callback);
  }

  off(event: DigilockerEventType, callback: (event: DigilockerEvent) => void): void {
    const eventListeners = this.listeners.get(event);
    if (eventListeners) {
      eventListeners.delete(callback);
      if (eventListeners.size === 0) {
        this.listeners.delete(event);
      }
    }
  }

  emit(event: DigilockerEventType, data?: any): void {
    const eventListeners = this.listeners.get(event);
    if (eventListeners) {
      const eventObj: DigilockerEvent = {
        type: event,
        timestamp: Date.now(),
        data
      };
      
      eventListeners.forEach(callback => {
        try {
          callback(eventObj);
        } catch (error) {
          console.error(`Error in event listener for ${event}:`, error);
        }
      });
    }
  }

  removeAllListeners(): void {
    this.listeners.clear();
  }

  getListenerCount(event: DigilockerEventType): number {
    return this.listeners.get(event)?.size || 0;
  }

  getTotalListenerCount(): number {
    let total = 0;
    for (const listeners of this.listeners.values()) {
      total += listeners.size;
    }
    return total;
  }
}

// Global event emitter instance
export const globalEventEmitter = new EventEmitter();
